// removed by extract-text-webpack-plugin
module.exports = {"box":"style__box___3czQr","box--error":"style__box--error___DIocC"};


//////////////////
// WEBPACK FOOTER
// ./components/TextArea/style.scss
// module id = 1234
// module chunks = 0